import { TypeConvention } from './type_convention';
import { formatDate } from '@angular/common';
export class Convention {

    con_id: string;
    con_tco_id: string;
    con_source: string;
    con_source_id: string;
    con_numero: string;
    con_date_signature: string;
    con_date_prise_effet: string;
    con_date_fin: string;
    type_convention: TypeConvention;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.con_id                        = data['con_id'] ? data['con_id'] : null;
        this.con_tco_id                    = data['con_tco_id'] ? data['con_tco_id'] : null;
        this.con_source                    = data['con_source'] ? data['con_source'] : null;
        this.con_source_id                 = data['con_source_id'] ? data['con_source_id'] : null;
        this.con_numero                    = data['con_numero'] ? data['con_numero'] : null;
        this.con_date_signature            = data['con_date_signature'] ? data['con_date_signature'] : null;
        this.con_date_prise_effet          = data['con_date_prise_effet'] ? data['con_date_prise_effet'] : null;
        this.con_date_fin                  = data['con_date_fin'] ? data['con_date_fin'] : null;
        this.type_convention               = data['type_convention'] ? new TypeConvention(data['type_convention']) : new TypeConvention();
    }

}
